module.exports = __webpack_public_path__ + "static/img/15areaA_1.8c64f1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/15areaA_1.png
// module id = 796
// module chunks = 1